<div class="layout_page w-100 h-100 scrollbar" id="scrollbar" :class="{'layout_Sup': layoutSup}" :theme="layoutTheme">
    <div class="container">
        <nav class="navbar navbar-expand-lg navbar-light px-0 justify-content-center">
            <router-link class="navbar-brand" to="/Dashboard" v-if="GetUserRole !== 8 ">
                <img :src="require( `../img/${logoLayoutSrc}.svg`)" width="220" />
            </router-link>
            <button class="navbar-toggler" type="button" @click="collapse">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" :class="{'show': collapsed}" id="navbarSupportedContent">
                <ul class="navbar-nav ml-auto">
                    <li v-for="item in menuForCurrentRole" :key="item.key" v-if="item.show" class="nav-item nav-item-menu" style="position: relative;">
                        <router-link v-if="!item.isDropdown" class="nav-link text-center" :to="item.route" exact-active-class="active-link"
                            :class="{ 'active-link': $route.path === item.route }" @click.native="closeMobileMenu">{{ item.text }}</router-link>
                        <template v-else-if="item.isDropdown && item.route">
                            <div class="nav-link nav-link-dropdown-parent d-flex align-items-center justify-content-center"
                                :class="{ 'show': isDropdownOpen(item.key), 'active-link': isDropdownParentActive(item) }">
                                <router-link :to="item.route" class="nav-link text-center"
                                    :class="{ 'active-link': $route.path === item.route }" @click.native="closeMobileMenu">
                                    {{ item.text }}
                                </router-link>
                                <span v-if="item.children && item.children.length > 0" class="nav-dropdown-toggle" @click.stop="openDropdown(item.key)">
                                    <i class="fas fa-caret-down nav-dropdown-caret"></i>
                                </span>
                            </div>
                            <ul v-if="item.children && item.children.length > 0" class="dropdown-menu dropdown-menu-center" :class="{ 'show': isDropdownOpen(item.key) }">
                                <li v-for="child in item.children" :key="child.key" v-if="child.show">
                                    <router-link :to="child.route" class="dropdown-item" exact-active-class="active-link"
                                        @click.native="closeMobileMenu">
                                        {{ child.text }}
                                    </router-link>
                                </li>
                            </ul>
                        </template>
                        <template v-else-if="item.isDropdown && !item.route">
                            <a class="nav-link dropdown-toggle" href="javascript:void(0);" @click.stop="openDropdown(item.key)"
                                :class="{ 'show': isDropdownOpen(item.key), 'active-link': isDropdownParentActive(item) }">
                                {{ item.text }}
                            </a>
                            <ul v-if="item.children && item.children.length > 0" class="dropdown-menu dropdown-menu-center" :class="{ 'show': isDropdownOpen(item.key) }">
                                <li v-for="child in item.children" :key="child.key" v-if="child.show">
                                    <router-link :to="child.route" class="dropdown-item" exact-active-class="active-link"
                                        @click.native="closeMobileMenu">
                                        {{ child.text }}
                                    </router-link>
                                </li>
                            </ul>
                        </template>
                    </li>
                    <li class="nav-item">
                        <div class="line"></div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link pr-0" href="javascript:void(0);" @click="showLogOutDialog">
                            {{$t('shared.logOut')}} <i class="fas fa-sign-out-alt"></i>
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        <router-view v-on:childinit="onChildInit" />
        <div class="layout_footer form-row justify-content-between align-items-center">
            <div class="col-auto">
                <a>
                    {{$t('shared.privacy')}}
                </a>
            </div>
            <div class="col-auto">
                <a>
                    {{$t('shared.termsOfUse')}}
                </a>
            </div>
            <div class="col-auto">
                <a>
                    {{$t('shared.copyRight')}} {{currentYear}}
                </a>
            </div>
        </div>
    </div>
    <div class="text-xs-center">
        <v-dialog v-model="logOutDialog" width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.logOut')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideLogOutDialog"></i>
                    </div>
                </v-card-title>

                <v-card-text class="text-center">
                    <i class="fas fa-sign-out-alt"></i>
                    <p class="mt-3">
                        {{$t('shared.logOutText')}}
                    </p>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center">
                        <div class="col-auto mx-3">
                            <a class="link_danger" @click="hideLogOutDialog">
                                {{$t('shared.no')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-danger px-5 py-2" @click="logOut">{{$t('shared.yes')}}</button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="loginDialog" persistent width="554">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    {{$t('shared.reLogin')}}
                    <div class="close__dialog">
                        <i class="fas fa-times" @click="hideLoginDialog"></i>
                    </div>
                </v-card-title>

                <v-card-text v-if="logInForm">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text">
                                        <img :src="require('../img/User.svg')" />
                                    </span>
                                </div>
                                <input type="text" class="form-control border-left-0" v-model="userName"
                                       :placeholder="$t('loginPage.userName')" />
                            </div>
                        </div>
                        <div class="col-md-12">
                            <div class="input-group mb-3">
                                <div class="input-group-prepend">
                                    <span class="input-group-text"><img :src="require('../img/Lock.svg')" /></span>
                                </div>
                                <input class="form-control border-right-0 border-left-0" v-model="password"
                                       v-bind:type="[showPassword ? 'text' : 'password']"
                                       maxlength="64"
                                       :placeholder="$t('loginPage.password')" />
                                <div class="input-group-append">
                                    <span class="input-group-text right">
                                        <i class="fas"
                                           :class="{ 'fa-eye-slash': showPassword, 'fa-eye': !showPassword }"
                                           @click="showPassword = !showPassword"></i>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-12" v-if="errorUserCertificate">
                            <div class="form-group">
                                <label class="red_text">{{$t('shared.errorUserCertificate')}}</label>
                            </div>
                        </div>
                    </div>
                </v-card-text>
                <v-card-text v-if="otpForm">
                    <label class="w-100 text-center text_body">
                        {{$t('loginPage.enterOtp')}} <br />
                        {{$t('loginPage.OtpReminingTime')}}: {{ countDown }}
                    </label>
                    <div class="row row_input pb-4">
                        <div class="col-md-12">
                            <div class="form-group">
                                <div class="input-group mb-3">
                                    <input type="text" class="form-control text-center" v-model="otp" />
                                </div>
                            </div>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="form-row justify-content-end align-items-center" v-if="logInForm">
                        <div class="col-auto mx-3">
                            <a class="link_login" @click="hideLoginDialog">
                                {{$t('shared.cancel')}}
                            </a>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary mb-2" :disabled="!isValid"
                                    @click="login">
                                {{$t('loginPage.login')}}
                            </button>
                        </div>
                    </div>
                    <div class="form-row justify-content-end align-items-center" v-if="otpForm">
                        <div class="col-auto mx-3">
                            <button class="btn btn-primary mb-2" :disabled="isResendValid"
                                    @click="resendOtp">
                                {{$t('loginPage.resendOtp')}}
                            </button>
                        </div>
                        <div class="col-auto">
                            <button class="btn btn-primary mb-2" :disabled="!isResendValid"
                                    @click="verfiyOTP">
                                {{$t('loginPage.verfiyOTP')}}
                            </button>
                        </div>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</div>